
import bannerLocker from './routes/banner_locker/bannerLocker.vue';
import createBannerLocker from './routes/banner_locker/component/createBannerLocker.vue';
import editBannerLocker from './routes/banner_locker/component/editBannerLocker.vue';

import servicesLocker from './routes/services_locker/servicesLocker.vue';
import createServicesLocker from './routes/services_locker/component/createServicesLocker.vue';
import editServicesLocker from './routes/services_locker/component/editServicesLocker.vue';

import guestBook from './routes/guest_book/guestBook.vue';
import editGuestBook from './routes/guest_book/component/editGuestBook.vue';

const LockerRoutes = [
    {
        path: '/guest-book',
        name: 'guestBook',
        component: guestBook,
    },
    {
        path: '/edit-guest-book',
        name: 'editGuestBook',
        component: editGuestBook,
    },
    {
        path: '/banner-locker',
        name: 'bannerLocker',
        component: bannerLocker,
    },
    {
        path: '/create-banner-locker',
        name: 'createBannerLocker',
        component: createBannerLocker,
    },
    {
        path: '/edit-banner-locker/:id',
        name: 'editBannerLocker',
        component: editBannerLocker,
    },
    {
        path: '/services-locker',
        name: 'servicesLocker',
        component: servicesLocker,
    },
    {
        path: '/create-services-locker',
        name: 'createServicesLocker',
        component: createServicesLocker,
    },
    {
        path: '/edit-services-locker/:id',
        name: 'editServicesLocker',
        component: editServicesLocker,
    },
];

export default LockerRoutes;
